import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { QuotePanelsTabsList } from "../../enums/QuotePanelsTabs.list";


@Injectable()
export class QuoteTabsActiveModeService {
    public subscriber: Subject<QuotePanelsTabsList> = new Subject<QuotePanelsTabsList>();
}